import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { apiFetch } from './client';
import { keys } from './keys';

const UnpricedResponseSchema = z.object({
  items: z.array(z.record(z.string(), z.unknown())),
  mtoOptions: z.array(z.record(z.string(), z.unknown())),
  defaultItems: z.array(z.record(z.string(), z.unknown())),
});

export function useCommunityUnpriced(communityId: string | undefined) {
  return useQuery({
    queryKey: keys.communityUnpriced(communityId ?? ''),
    enabled: !!communityId,
    queryFn: () => apiFetch(`/api/communities/${communityId}/unpriced`, UnpricedResponseSchema),
  });
}
